import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { Input } from '~stories'

import styles from './UniversalTemplateFields.module.css'

const { Text } = Typography

const UniversalTemplateFormFields = ({ form, onChange }) => {
  const { url = '', form_name: formName = '' } = form || {}

  const patch = updates => onChange({ ...form, ...updates })

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Form name</Text>
        <Input
          onChange={e => patch({ form_name: e.target.value })}
          placeholder="e.g. Contact Form"
          value={formName}
        />
        <Text className={styles.hint}>Internal display name for this form</Text>
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Form URL</Text>
        <Input
          onChange={e => patch({ url: e.target.value })}
          placeholder="https://form.example.com/embed"
          value={url}
        />
        <Text className={styles.hint}>Embed or redirect URL for the form</Text>
      </div>
    </div>
  )
}

UniversalTemplateFormFields.propTypes = {
  form: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default UniversalTemplateFormFields
